import { Form, Select, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { errorHandler } from '../../../utils';
import Ampliacion from './Ampliacion';

const EstadoInspeccionComentarios = ({
  inspeccion,
  updateInspeccion,
  onChangeAmpliacion,
  cantampli,
  setResult,
  user
}) => {
  const [estadoVehiculo, setEstadoVehiculo] = useState();
  const [showAmpliacion, setShowAmpliacion] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const secreoampliacion = async () => {
    setResult();
  };

  const onChangeEstadoVehiculo = async (value) => {
    setEstadoVehiculo(value);
    try {
      await updateInspeccion(value);
    } catch (err) {
      errorHandler(err);
    }
  };

  const onChange = async (value) => {
    onChangeAmpliacion(!value);
    setShowAmpliacion(value);
  };

  const getAmpliacion = () => {
    if (showAmpliacion) {
      return (
        <Ampliacion
          inspeccion={inspeccion}
          creoampliacion={secreoampliacion}
          cantampli={cantampli}
        />
      );
    }
    return <p />;
  };

  useEffect(() => {
    if (inspeccion.estado_vehiculo) {
      setEstadoVehiculo(inspeccion.estado_vehiculo);
    }
    if (
      inspeccion.estado === 'FOTOS_SUBIDAS' &&
      inspeccion.resultado !== 'VERIFICACION' &&
      !user
    ) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [inspeccion, user]);

  return (
    <div style={{ paddingTop: 32 }}>
      <Form
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 14
        }}
        layout="vertical"
        initialValues={{
          size: 'default'
        }}
      >
        <Form.Item label="Estado del Vehículo">
          <Select
            value={estadoVehiculo}
            onChange={(value) => {
              onChangeEstadoVehiculo(value);
            }}
            disabled={isDisabled}
            placeholder="Seleccionar"
          >
            <Select.Option value="VEHICULO EN BUEN ESTADO">
              VEHICULO EN BUEN ESTADO
            </Select.Option>
            <Select.Option value="VEHICULO CON DAÑOS LEVES">
              VEHICULO CON DAÑOS LEVES
            </Select.Option>
            <Select.Option value="VEHICULO EN MAL ESTADO">
              VEHICULO EN MAL ESTADO
            </Select.Option>
          </Select>
        </Form.Item>

        {!user && (
          <Form.Item label="¿Desea solicitar una Ampliación?">
            <Switch
              onChange={(value) => {
                onChange(value);
              }}
              disabled={isDisabled}
            />
          </Form.Item>
        )}
      </Form>
      {getAmpliacion()}
    </div>
  );
};

export default EstadoInspeccionComentarios;
